import React from 'react';
import ChatPerson from './ChatPerson';
import SkeletonLoader from './SkeletonLoader';

const ChatList = ({selectedConversation, conversations, loading, selectConversation }: any) => {
  return (
    <>
      {loading ? (
        <SkeletonLoader />
      ) : (
        conversations.map((c: any) => (
          <ChatPerson data={c} selectedConversation={selectedConversation} key={c.sid} name={c.friendlyName || 'person'} type="client" onClick={() => selectConversation(c)} />
        ))
      )}
    </>
  );
};

export default ChatList;
